// Single source of truth for BizMak Inc company data.
// Sourced from the official BizMak Inc Capability Statement.
// Update here once — every section of the site reads from this file.

const companyInfo = {
  legalName: "BizMak Inc",
  tagline: "Enterprise software and IT services for business and government",
  founded: "Catonsville, Maryland",

  contact: {
    name: "Carolina Fernandez",
    title: "President",
    phone: "(443) 951-5651",
    phoneHref: "tel:+14439515651",
    email: "info@bizmaks.com",
    govEmail: "Cfernandez@bizmaks.com",
    address: "Catonsville, MD 21228",
  },

  federal: {
    uei: "D3ALVYC51FJ6",
    cageCode: "9GFT0",
    samStatus: "Active SAM.gov registration",
    primaryNaics: "541512",
    naicsCodes: [
      { code: "541512", name: "Computer Systems Design Services", primary: true },
      { code: "541511", name: "Custom Computer Programming Services" },
      { code: "541519", name: "Other Computer Related Services" },
      { code: "541513", name: "Computer Facilities Management Services" },
      { code: "513210", name: "Software Publishers" },
      { code: "541430", name: "Graphic Design Services" },
      { code: "541612", name: "Human Resources Consulting Services" },
      { code: "541860", name: "Direct Mail Advertising" },
      { code: "541990", name: "All Other Professional, Scientific & Technical Services" },
      { code: "611420", name: "Computer Training" },
    ],
    // Served from S3 so the nano EC2 never transfers the PDF.
    capabilityStatementUrl:
      "https://bizmaks-contract-app-prod.s3.us-east-2.amazonaws.com/assets/Bizmak-Capability-Statement.pdf",
  },

  clients: [
    { name: "ADT Inc", img: "adt-security-services-logo.jpg" },
    { name: "CGI Inc", img: "cgi-federal.jpg" },
    { name: "The Judge Group", img: "judge.jpg" },
  ],

  pastPerformance: [
    {
      agency: "U.S. Department of the Navy",
      parent: "Department of Defense",
      status: "Active contract",
      description:
        "BizMak Inc is an active contract holder supporting the U.S. Department of the Navy under the Department of Defense — delivering on time, on budget, and to federal compliance standards.",
    },
  ],

  coreCompetencies: [
    "Custom software development & programming",
    "Software testing & quality assurance automation",
    "Cloud computing, migration & storage solutions",
    "Cybersecurity, threat detection & IT compliance",
    "Data analysis, business intelligence & database administration",
    "IT consulting, strategy & project management",
    "System integration & legacy modernization",
    "Website, mobile app & e-commerce development",
    "IT outsourcing, managed services & remote monitoring",
    "Virtualization & containerization services",
  ],

  differentiators: [
    "Department of Defense past performance — active contract holder supporting the U.S. Department of the Navy.",
    "Fortune 500 track record — ADT Inc, CGI Inc, and The Judge Group rely on BizMak to deliver their IT requirements.",
    "Automation specialists — we transform paper-based processes into efficient web-based systems, reducing errors and cutting turnaround time.",
    "Security-first delivery — robust protection against cyber threats and data breaches built into every engagement.",
    "Cost-effective flexibility — competitive pricing, flexible service plans, and scalable teams that eliminate the need for in-house IT staff.",
  ],
};

export default companyInfo;
